<template>
    <div class="mt-5 mb-8 px-4">
        <UIHtml
            :html="config.data.body"
            class="prose prose-sm max-w-full"
            style="overflow-wrap: anywhere;"
        />
    </div>
</template>

<script setup>
    import UIHtml from '@/components/ui/UIHtml.vue'

    const props = defineProps({
        config: Object,
    })
</script>
